









import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe, PageTitle },
})
export default class JudgementListIframe extends Vue {
  private get remoteSrc() {
    const queryString = new URLSearchParams({ ...this.$route.query, serviceType: 'PREMIUM' }).toString();
    return process.env.VUE_APP_ADMIN_REMOTE_URL + `/product/management/screening-list?${queryString}`;
  }
}
